import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { convertToHtml, formatDateString } from "../../utils/commonFunctions";
import Carosel from "../../components/Carousel";

import Profile from '../../assets/icons/icon_profile.png';
import AI from '../../assets/icons/icon_ai.png';
import Toggle from '../../assets/icons/icon_folderble.png';
import Copy from '../../assets/icons/icon_copy.png';

import { CopyToClipboard } from "react-copy-to-clipboard";
import Warning from "../../components/Warning";

const URLS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  CREATE_URL: process.env.REACT_APP_TUTOR_SHARE_LINK,
  REDIRECT: process.env.REACT_APP_REFERER_URL,
  JOIN_URL: `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}` // process.env.REACT_APP_JOIN_URL,
}

const toShareDetailUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  // dl 상세 페이지는 referer 파라미터로 로고를 분기함 (없으면 에듀 로고)
  const shareUrl = url.replace("/detail/", "/shareDetail/");
  return `${shareUrl}${shareUrl.includes("?") ? "&" : "?"}referer=air`;
};

/**
 * 공유된 페이지 대화 이력 렌더링
 */
const SharePage = () => {
  const { uuid } = useParams();
  const [data, setData] = useState({
    chat_list: [],
    title: null,
    created_at: null
  });

  const generateCopyText = (item) => {
    let text = `\n과학동아AiR. ${item?.input_text} (${formatDateString(data.created_at)})\n\n`;
    text += `${item.response}\n\n`
    text += `[참고자료], ${URLS.BASE_URL}${URLS.REDIRECT}/share/${uuid}\n`
    item.reference.forEach(ref => {
      text += `${ref.medium} - ${ref.name} - ${ref.url}\n`;
    });
    return text;
  };

  /**
   * 링크로 연결
   * @param {공유 기사 url} url 
   */
  const linkToPage = url => {
    window.open(toShareDetailUrl(url), "_blank")
  }

  /**
   * API 호출 함수
   * @returns API response obj
   */
  const touchAPI = async () => {
    try {
      const response = await fetch(`${URLS.BASE_URL}${URLS.CREATE_URL}/${uuid}`)
      const resData = response?.json();
      if (response.status === 200) {
        return resData
      } else {
        // navigation('/NotFound')
      }
      // .then(response => response.json())
      // .then(data => setData(data))
      // .catch(error => console.error('Error fetching data:', error));
    } catch (error) {
      console.error("공유 페이지 조회 실패:", error);
      // navigation('/NotFound')
    }

  }

  const getThumbnailImage = (imageArray) => {
    if (!imageArray || imageArray.length === 0) return null;
    const validImage = imageArray.find(img => img.IMG_SRC);
    return validImage ? validImage.IMG_SRC : null;
  };


  const toggleRefs = (item, idx) => {
    setData((prev) => {
      const updatedChatList = prev.chat_list.map((chat, index) => {
        if (index === idx) {
          return { ...chat, isShowDetail: !chat.isShowDetail };
        }
        return chat;
      });
      return { ...prev, chat_list: updatedChatList };
    });
  };

  const handleCopy = () => {
    setWarnSetting(prev => ({
      ...prev,
      warningTxt: '내용이 복사되었습니다.',
    }))
  }

  /**
  * warning Handler 
  */
  const clearWarnState = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: '',
    })
    setIsWarning(false)
  }
  const [isWarning, setIsWarning] = useState(false);
  const [warnSetting, setWarnSetting] = useState({
    warningTxt: '',
    onClose: () => clearWarnState(),
  })
  useEffect(() => {
    if (warnSetting.warningTxt !== '') {
      setIsWarning(true)
    }
  }, [warnSetting.warningTxt])


  useEffect(() => {
    // 예시로 API 호출을 통해 UUID 값을 기반으로 데이터를 가져오는 경우
    const getData = async () => {
      const response = await touchAPI();
      if (response?.chat_list && response?.chat_list?.length > 0) {
        const updatedData = {
          ...response,
          chat_list: response?.chat_list?.map(chat => ({ ...chat, isShowDetail: false }))
        };
        setData(updatedData);
      }
    }
    getData();

  }, [uuid]);

  if (!data.title) {
    return <div style={{ textAlign: 'center', margin: '30% 0' }} className="no-data">no data...</div>;
  }


  return (
    <div className="share-page">
      <div className="title">
        <h1>{data?.title}</h1>
        <p>{formatDateString(data?.created_at)}</p>
      </div>
      {/* 데이터를 렌더링 */}
      {
        data.chat_list && data?.chat_list?.length > 0 &&
        data?.chat_list?.map((item, idx) => {
          return (
            <div className="share-ls" key={item.response_id}>
              <div className="share-ques">
                <div className="flx-box">
                  <div
                    className="profile-wrp flx-box">
                    <img
                      src={Profile}
                      // src={Profile}
                      alt="user-profile" />
                  </div>
                  <p>나</p> 
                </div>
                <p className="share-ques__txt break-all">{item.input_text}</p>
              </div>


              <div className="share-ans flx-box" >

                <div className="share-ans__lg" >
                  <div className="flx-box">
                    <div className="icon_wrp flx-box">
                      <img src={AI} alt="donga-icon" />
                    </div>
                    <p>과학동아AiR</p>
                  </div>
                </div>

                <div className="share-ans__bg" >
                  {
                    // clario 일반  답변
                    item.response && (item.action === 'chat' || item.action === 'stop')
                      ?
                      (
                        <div className="share-ans__txt">
                          {typeof (item.response) === 'string'
                            ?
                            convertToHtml(item.response)
                            :
                            item.response
                          }

                          <div className="share-ans__refs flx-box" style={(Array.isArray(item?.reference) && item?.reference?.length > 0 && item?.reference[0]?.image?.length > 0) ? null : { display: 'none' }}>
                            {
                              Array.isArray(item?.reference) && item?.reference?.length !== 0 && item.reference[0]?.image?.length > 0
                              &&
                              <div className="ref-title">📂 이런 자료를 참고했어요.</div>
                            }
                            {
                              (Array.isArray(item.reference) && item.reference.length !== 0 && item.reference[0].image?.length > 0) &&
                              <Carosel slides={item.reference} chat={true} key={`${item.response_id}-${idx}`} />
                            }
                          </div>
                        </div>
                      )

                      : item.action === 'rec'
                        ?
                        // 기사 추천
                        <div className="rec__box">
                          <ul className="rec__box-list">
                            <p className="rec__box-inform">{item.response}</p>
                            {
                              (Array.isArray(item.search_result) && item.search_result.length !== 0) &&
                              <Carosel slides={item.search_result} chat={false} search />
                            }
                          </ul>
                        </div>
                        : item.action === 'error'
                          ?
                          <div className="share-ans__txt" >{item.response}</div>
                          : null
                  }

                 
                </div>
               <div className="usr-rct flx-box sep-elm pt-5 pb-[10px]" >
                    <div className="usr-cp flx-box">
                      <CopyToClipboard text={generateCopyText(item)} onCopy={handleCopy}>
                        <img src={Copy} alt="copy-btn" className="crs-btn" />
                      </CopyToClipboard>
                    </div>

                  </div>
              </div>


              {
                (Array.isArray(item.reference) && item.reference?.length !== 0) &&
                <div className="more-btn crs-btn flx-box sep-elm dark-txt" onClick={() => toggleRefs(item, idx)}>
                  <img className={`${item.isShowDetail ? '' : 'reverse'}`} src={Toggle} alt="toggle-btn" />
                  <p className="dark-txt">{`참고 자료 ${item.isShowDetail ? '닫기' : '보기'}`}</p>
                </div>
              }
              {
                item.isShowDetail &&
                <div className="ref-detail__wrp">
                  {item.reference.map((refItem, refIdx) => (
                    <div className="ref-defail__item">
                      <div className="ref-detail__top flx-box">
                        <div className="ref-detail__title">{refIdx + 1}. {refItem.medium}</div>
                      </div>
                      <div className="ref-detail__bottom crs-btn flx-box sep-elm" onClick={() => linkToPage(refItem.url)}>
                        <div className="left">
                          <p className="left-title">{refItem.name}</p>
                          <p className="left-desc">{refItem.summary}</p>
                        </div>
                        {
                          refItem.image?.length > 0 &&
                          <div className="right">
                            <img src={getThumbnailImage(refItem.image)} alt={`Thumbnail for ${refItem.name}`} />
                          </div>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              }
              {
                (Array.isArray(item.recommended_questions) && item.recommended_questions.length > 0)
                &&
                <div className="share-ans__rec flx-box">

                  <p className="share-ans__rec-title">😀 이런 질문을 할 수 있어요!</p>

                  {
                    item.recommended_questions
                    &&
                    item.recommended_questions.map((recItem, recIdx) => {
                      return (
                        <div key={recItem} className="share-ans__rec-txt" >
                          {`Q. ${recItem}`}
                        </div>
                      )
                    })
                  }
                </div>
              }


            </div>
          )
        })
      }
      <button className="positive-btn" onClick={() => linkToPage(URLS.JOIN_URL)}>과학동아AiR 시작하기</button>
      {
        isWarning &&
        <Warning settings={warnSetting} />
      }
    </div>
  );
};

export default SharePage;
